
import { Injectable } from '@angular/core';
import { MCEnvironmentsService, Store } from '@maslul/common-services';
import { Observable } from 'rxjs';
import { SecondRequest } from '../../models/request-submission-methods/approvalType/secondRequest';
import { TABS } from '../../enum/request/TABS';



export class RequestApprovalTypeDetails {
    authorityId: string = "";
    typeCode: string = "";
    secondRequest: string = "";
    approvalTypeId: string = "";
    approvalTypeName: string = "";
    approvalMainTypeName: string = "";
    approvalTypes: SecondRequest[] = [];
    approvalTabs: TABS[] | number[] = [];
    is4DigitsCustomItem: boolean = false;
}
const REQUEST_APPROVAL_TYPE_DETAILS: RequestApprovalTypeDetails =
{
    authorityId: "",
    approvalTypeName: "",
    typeCode: "",
    secondRequest: "",
    approvalTypeId: "",
    approvalMainTypeName: "",
    approvalTypes: [],
    approvalTabs: [],
    is4DigitsCustomItem: false
}

@Injectable({
    providedIn: 'root',
}) export class RequestApprovalTypeDetailsStore extends Store<RequestApprovalTypeDetails> {

    constructor(protected override environmentsService: MCEnvironmentsService) {
        super('', REQUEST_APPROVAL_TYPE_DETAILS, environmentsService);
    }

    getAuthorityId(): Observable<string> {
        return this.select(s => s.authorityId);
    }

    setAuthorityId(authorityId: string) {
        this.updateState('[Request Approval Type Details Store Service] set authorityId', { authorityId })
    }

    getIs4DigitsCustomItem(): Observable<boolean> {
        return this.select(s => s.is4DigitsCustomItem);
    }

    setIs4DigitsCustomItem(is4DigitsCustomItem: boolean) {
        this.updateState('[Request Approval Type Details Store Service] set is4DigitsCustomItem', { is4DigitsCustomItem })
    }

    getTypeCode(): Observable<string> {
        return this.select(s => s.typeCode);
    }

    setTypeCode(typeCode: string) {
        this.updateState('[Request Approval Type Details Store Service] set typeCode', { typeCode })
    }

    getSecondRequest(): Observable<string> {
        return this.select(s => s.secondRequest);
    }

    setSecondRequest(secondRequest: string) {
        this.updateState('[Request Approval Type Details Store Service] set SecondRequest', { secondRequest })
    }

    getApprovalTypeId(): Observable<string> {
        return this.select(s => s.approvalTypeId);
    }

    setApprovalTypeId(approvalTypeId: string) {
        this.updateState('[Request Approval Type Details Store Service] set approvalTypeId', { approvalTypeId })
    }

    getApprovalTypeName(): Observable<string> {
        return this.select(s => s.approvalTypeName);
    }

    setApprovalTypeName(approvalTypeName: string) {
        this.updateState('[Request Approval Type Details Store Service] set approvalTypeName', { approvalTypeName })
    }

    getApprovalMainTypeName(): Observable<string> {
        return this.select(s => s.approvalMainTypeName);
    }

    setApprovalMainTypeName(approvalMainTypeName: string) {
        this.updateState('[Request Approval Type Details Store Service] set approvalMainTypeName', { approvalMainTypeName })
    }

    getApprovalTypes(): Observable<SecondRequest[]> {
        return this.select(s => s.approvalTypes);
    }

    setApprovalTypes(approvalTypes: SecondRequest[]) {
        this.updateState('[Request Approval Type Details Store Service] set approvalTypes', { approvalTypes })
    }

    getApprovalTabs(): Observable<TABS[] | number[]> {
        return this.select(s => s.approvalTabs);
    }

    setApprovalTabs(approvalTabs: TABS[] | number[]) {
        this.updateState('[Request Approval Type Details Store Service] set approvalTabs', { approvalTabs })
    }

}